import {Injectable, EventEmitter, Inject, PLATFORM_ID} from '@angular/core';
import {Store} from '@ngrx/store';
import {Md5} from 'ts-md5/dist/md5';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {take} from 'rxjs/operators';
import {config} from 'src/app/config';
import Swal from 'sweetalert2';

import * as fromRoot from '../store/reducers/appState';
import {RestaurantData} from '../store/actions/restaurant';
import {CLEAR, ADD_ITEM, UPDATE_QUANTITY, DELETE_ITEM, RESTORE_EXISTING_DATA} from '../store/reducers/cart';
import {SELECTED_DISH} from '../store/reducers/selected_dish';
import {SAVE_SELECTED_POLICY, RESTORE_SELECTED_POLICY, CLEAR_SELECTED_POLICY} from '../store/reducers/policyReducer';
import {SIGN_IN, RESTORE_USER, UPDATE_USER, REMOVE_USER} from '../store/reducers/signInReducer';
import {SET_ROUTE_PAGE} from '../store/reducers/routeReducer';
import {AVAILABLE_PROMOTION, RESTORE_AVAILABLE_PROMOTION, CLEAR_AVAILABLE_PROMOTION} from '../store/reducers/available_promotion';
import {ACCEPTED_PROMOTION, RESTORE_ACCEPTED_PROMOTION, CLEAR_ACCEPTED_PROMOTION} from '../store/reducers/accepted_promotion';
import {PUSH_DELIVERY_ADDRESS} from '../store/reducers/customer_delivery_address_reducer';
import {GENERATE_SCHEDULE} from '../store/reducers/schedule';
import {BOOKING} from '../store/reducers/bookingReducer';
import {STORE_DELIVERY_TIME, RESTORE_DELIVERY_TIME, CLEAR_DELIVERY_TIME} from '../store/reducers/deliveryTimeReducer';
import {VIEW_ITEM_MODAL} from '../store/reducers/common_modal_reducer';
import {SAVE_BOOKING_TIMES} from '../store/reducers/booking_times';
import {SAVE_PAYMENT_METHOD, RESTORE_PAYMENT_METHOD, CLEAR_PAYMENT_METHOD} from '../store/reducers/paymentMethodReducer';
import {SAVE_ORDER_NOTES, RESTORE_ORDER_NOTES, CLEAR_ORDER_NOTES} from '../store/reducers/orderNotesReducer';
import {_SAVE_DELIVERY_CHARGE} from '../store/reducers/delivery_charge_reducer';
import {_SAVE_PARCEL_INFO} from '../store/reducers/parcelReducer';
import {ADD_COUPON, CLEAR_COUPON} from '../store/reducers/couponReducer';
import {RES_CLEAR, RES_ADD_ITEM, RES_UPDATE_QUANTITY, RES_DELETE_ITEM, RES_RESTORE_EXISTING_DATA} from '../store/reducers/resCartReducer';
import {ADD_MENU, CLEAR_MENU} from '../store/reducers/restaurant_menu_reducer';


@Injectable()
export class StoreService {
  errors_data = new EventEmitter<any>();
  delivery_time2 = new EventEmitter<any>();
  editUserData = new EventEmitter<any>();
  signUpForm = new EventEmitter<any>();
  bookingProgress = new EventEmitter<any>();
  orderProgress = new EventEmitter<any>();
  confirmOrderUponAccept = new EventEmitter<any>();
  restaurantData: Observable<any>;
  cartData: Observable<any>;
  selectedDishData: Observable<any>;
  user: Observable<any>;
  selected_policy: Observable<any>;
  route_page: Observable<any>;
  delivery_address: Observable<any>;
  available_promotion: Observable<any>;
  accepted_promotion: Observable<any>;
  schedule: Observable<any>;
  bookingData: Observable<any>;
  delivery_time: Observable<any>;
  common_data: Observable<any>;
  booking_time_list: Observable<any>;
  paymentMethod: Observable<any>;
  orderNotes: Observable<any>;
  deliveryCharge: Observable<any>;
  parcelInformation: Observable<any>;
  coupon: Observable<any>;
  resCartData: Observable<any>;
  restaurantMenu: Observable<any>;


  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any, 
    private router: Router,
    public db: Store<fromRoot.State>
  ) {
    this.restaurantData = this.db.select(state => state.restaurant);
    this.cartData = this.db.select(state => state.cart);
    this.selectedDishData = this.db.select(state => state.selected_dish);
    this.user = this.db.select(state => state.user);
    this.selected_policy = this.db.select(state => state.selected_policy);
    this.route_page = this.db.select(state => state.route_page);
    this.delivery_address = this.db.select(state => state.delivery_address);
    this.available_promotion = this.db.select(state => state.available_promotion);
    this.accepted_promotion = this.db.select(state => state.accepted_promotion);
    this.schedule = this.db.select(state => state.schedule);
    this.bookingData = this.db.select(state => state.booking);
    this.delivery_time = this.db.select(state => state.delivery_time);
    this.common_data = this.db.select(state => state.common_data);
    this.booking_time_list = this.db.select(state => state.booking_time_list);
    this.paymentMethod = this.db.select(state => state.paymentMethod);
    this.orderNotes = this.db.select(state => state.orderNotes);
    this.deliveryCharge = this.db.select(state => state.deliveryCharge);
    this.parcelInformation = this.db.select(state => state.parcelInformation);
    this.coupon = this.db.select(state => state.coupon);
    this.resCartData = this.db.select(state => state.resCart);
    this.restaurantMenu = this.db.select(state => state.restaurantMenu);
  }

  saveRestaurantData(data: any) {
    this.db.dispatch(new RestaurantData(data));
  }

  saveSelectedDish(data: any) {
    this.db.dispatch({type: SELECTED_DISH, payload: data});
  }

  addToCart(data: any) {
    this.db.dispatch({type: ADD_ITEM, payload: data});
    this.cartData.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('cartData', JSON.stringify(resp));
        }
      }
    });
  }

  updateToCart(dish: any, index: any) {
    this.db.dispatch({type: UPDATE_QUANTITY, payload: {dish: dish, index : index}});
    this.cartData.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('cartData', JSON.stringify(resp));
        }
      }
    });
  }

  removeToCart(cartIndex: any) {
    this.db.dispatch({type: DELETE_ITEM, payload: cartIndex});
    this.cartData.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('cartData', JSON.stringify(resp));
        }
      }
    });
  }

  storeExistingCartData() {
    if (this.platformId === 'browser') {
      if (sessionStorage.getItem('cartData') && sessionStorage.getItem('generated_cart_data')) {
        const cartDataStr = sessionStorage.getItem('cartData');
        const generatedCartDataStr = sessionStorage.getItem('generated_cart_data');
        if (!cartDataStr || !generatedCartDataStr) {
          return;
        }
        const data = JSON.parse(cartDataStr);
        const generate_data = JSON.parse(generatedCartDataStr);
        
        const md5 = new Md5();
        let checksum = md5.appendStr(JSON.stringify(data)).end();
        if(checksum === generate_data) {
          this.db.dispatch({type: RESTORE_EXISTING_DATA, payload: data});
        } else {
          sessionStorage.removeItem('cartData');
          this.db.dispatch({type: CLEAR});
        }
      }
    }
  }

  saveLoginData(data: any) {
    this.db.dispatch({type: SIGN_IN, payload: data});
    // Persist directly from the dispatched payload. Subscribing to the store here
    // (without ever unsubscribing) leaked a new subscription on every call and,
    // more importantly, could persist an undefined token as the string
    // "undefined", silently invalidating the session on the next request.
    if (this.platformId === 'browser') {
      if (data && data['isLogged'] === true) {
        localStorage.setItem('user', JSON.stringify(data['data']));
        // Only overwrite the token when a real one is supplied; never clobber a
        // valid token with undefined/empty (e.g. profile or address updates that
        // do not carry a fresh token).
        if (data['token']) {
          localStorage.setItem('token', data['token']);
        }
      } else {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
      }
    }
  }
  storeExistingLoginData() {
    if (this.platformId === 'browser') {
      if (localStorage.getItem('user') && localStorage.getItem('token')) {
        const userStr = localStorage.getItem('user');
        if (!userStr) {
          this.db.dispatch({type: RESTORE_USER, payload: {isLogged: false}});
          return;
        }
        const user = JSON.parse(userStr);
        const token = localStorage.getItem('token');
        this.db.dispatch({type: RESTORE_USER, payload: {isLogged: true, data: user, token: token}});
      } else {
        this.db.dispatch({type: RESTORE_USER, payload: {isLogged: false}});
      }
    }
  }
  
  updateUserData(data?: any) {
    if (this.platformId === 'browser'){
      if (localStorage.getItem('user') && localStorage.getItem('token')) {
        const userStr = localStorage.getItem('user');
        if (!data && !userStr) {
          return;
        }
        const user = data ? data : JSON.parse(userStr as string);
        const token = localStorage.getItem('token');
        const new_user_data = {
          ...user,
          total_orders: Number(user['total_orders'] + 1)
        }
        this.db.dispatch({ type: UPDATE_USER, payload: {isLogged: true, data: new_user_data, token: token} });
        localStorage.setItem('user', JSON.stringify(new_user_data));
      }
    }
  }



  /**POLICY action**/
  saveSelectedPolicy(data: any) {
    this.db.dispatch({type: SAVE_SELECTED_POLICY, payload: data});
  }

  private isCartItemPolicyCompatible(item: any, selectedPolicy: string): boolean {
    if (!selectedPolicy) {
      return true;
    }
    const policyRestriction = item?.policy_restriction || item?._policyRestriction || null;
    if (!policyRestriction) {
      return true;
    }
    if (policyRestriction === 'CONFLICT') {
      return false;
    }
    return policyRestriction === selectedPolicy;
  }

  clearIncompatibleItemsByPolicy(
    selectedPolicy: string,
    onComplete?: (result: { cartRemoved: number; resCartRemoved: number; totalRemoved: number }) => void
  ) {
    if (!selectedPolicy) {
      if (onComplete) {
        onComplete({ cartRemoved: 0, resCartRemoved: 0, totalRemoved: 0 });
      }
      return;
    }

    const result = {
      cartRemoved: 0,
      resCartRemoved: 0,
      totalRemoved: 0
    };

    let completedStreams = 0;
    const notifyCompletion = () => {
      completedStreams += 1;
      if (completedStreams === 2 && onComplete) {
        result.totalRemoved = result.cartRemoved + result.resCartRemoved;
        onComplete(result);
      }
    };

    this.cartData.pipe(take(1)).subscribe((items: any) => {
      if (!Array.isArray(items)) {
        notifyCompletion();
        return;
      }
      const filteredCartItems = items.filter(item => this.isCartItemPolicyCompatible(item, selectedPolicy));
      result.cartRemoved = items.length - filteredCartItems.length;
      if (filteredCartItems.length !== items.length) {
        this.db.dispatch({type: RESTORE_EXISTING_DATA, payload: filteredCartItems});
        if (this.platformId === 'browser') {
          sessionStorage.setItem('cartData', JSON.stringify(filteredCartItems));
        }
      }
      notifyCompletion();
    });

    this.resCartData.pipe(take(1)).subscribe((items: any) => {
      if (!Array.isArray(items)) {
        notifyCompletion();
        return;
      }
      const filteredResCartItems = items.filter(item => this.isCartItemPolicyCompatible(item, selectedPolicy));
      result.resCartRemoved = items.length - filteredResCartItems.length;
      if (filteredResCartItems.length !== items.length) {
        this.db.dispatch({type: RES_RESTORE_EXISTING_DATA, payload: filteredResCartItems});
        if (this.platformId === 'browser') {
          sessionStorage.setItem('resCartData', JSON.stringify(filteredResCartItems));
        }
      }
      notifyCompletion();
    });
  }
  storeExistingSelectedPolicy() {
    if (this.platformId === 'browser') {
      if (sessionStorage.getItem('policy')) {
        const policyStr = sessionStorage.getItem('policy');
        if (!policyStr) {
          return;
        }
        const data = JSON.parse(policyStr);
        this.db.dispatch({type: RESTORE_SELECTED_POLICY, payload: data});
      }
    }
  }

  /**Set redirect page**/
  setRoutePage(data: any) {
    /* {page:'checkout', data: null}*/
    this.db.dispatch({type: SET_ROUTE_PAGE, payload: data});
  }

  saveBookingTimes(data: any) {
    /* {page:'checkout', data: null}*/
    this.db.dispatch({type: SAVE_BOOKING_TIMES, payload: data});
  }


  /**Save customer delivery address**/

  saveDeliveryAddress(data: any) {
    this.db.dispatch({type: PUSH_DELIVERY_ADDRESS, payload: data});
  }

  saveAvailablePromotion(data: any) {
    this.db.dispatch({type: AVAILABLE_PROMOTION, payload: data});
    this.available_promotion.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('availablePromoData', JSON.stringify(resp));
        }
      }
    });
  }
  storeExistingAvailablePromotion() {
    if (this.platformId === 'browser') {
      if (sessionStorage.getItem('availablePromoData')) {
        const availablePromoDataStr = sessionStorage.getItem('availablePromoData');
        if (!availablePromoDataStr) {
          return;
        }
        const data = JSON.parse(availablePromoDataStr);
        this.db.dispatch({type: RESTORE_AVAILABLE_PROMOTION, payload: data});
      }
    }
  }

  saveAcceptedPromotion(data: any) {
    this.db.dispatch({type: ACCEPTED_PROMOTION, payload: data});
    this.accepted_promotion.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('acceptedPromoData', JSON.stringify(resp));
        }
      }
    });
  }
  storeExistingAcceptedPromotion() {
    if (this.platformId === 'browser') {
      if (sessionStorage.getItem('acceptedPromoData')) {
        const acceptedPromoDataStr = sessionStorage.getItem('acceptedPromoData');
        if (!acceptedPromoDataStr) {
          return;
        }
        const data = JSON.parse(acceptedPromoDataStr);
        this.db.dispatch({type: RESTORE_ACCEPTED_PROMOTION, payload: data});
      }
    }
  }

  setDeliveryTime(time: any) {
    this.delivery_time2.emit(time);
  }

  saveSchedule(data: any) {
    this.db.dispatch({type: GENERATE_SCHEDULE, payload: data});
  }

  storeDeliveryTime(data: any) {
    this.db.dispatch({type: STORE_DELIVERY_TIME, payload: data});
    this.delivery_time.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('time', JSON.stringify(resp));
        }
      }
    });
  }
  storeExistingDeliveryTime(){
    if (this.platformId === 'browser') {
      if (sessionStorage.getItem('time')) {
        const timeStr = sessionStorage.getItem('time');
        if (!timeStr) {
          return;
        }
        const data = JSON.parse(timeStr);
        this.db.dispatch({type: RESTORE_DELIVERY_TIME, payload: data});
      }
    }
  }

  setPaymentMethod(data: any) {
    this.db.dispatch({type: SAVE_PAYMENT_METHOD, payload: data});
    this.paymentMethod.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('payment_method', JSON.stringify(resp));
        }
      }
    });
  }
  setExistingPaymentMethod() {
    if (this.platformId === 'browser') {
      if (sessionStorage.getItem('time')) {
        const paymentMethodStr = sessionStorage.getItem('payment_method');
        if (!paymentMethodStr) {
          return;
        }
        const data = JSON.parse(paymentMethodStr);
        this.db.dispatch({type: RESTORE_PAYMENT_METHOD, payload: data});
      }
    }
  }

  resetCartAfterPlacingOrder() {
    if (this.platformId === 'browser') {
      sessionStorage.clear();
      this.updateUserData();
      this.db.dispatch({type: CLEAR});
      this.db.dispatch({type: CLEAR_SELECTED_POLICY});
      this.db.dispatch({type: CLEAR_DELIVERY_TIME});
      this.db.dispatch({type: CLEAR_AVAILABLE_PROMOTION});
      this.db.dispatch({type: CLEAR_ACCEPTED_PROMOTION});
      this.db.dispatch({type: CLEAR_ORDER_NOTES});
      this.db.dispatch({type: CLEAR_PAYMENT_METHOD});
    }
  }

  saveBookingInfo(data: any) {
    this.db.dispatch({type: BOOKING, payload: data});
  }

  editUserInformation(data: any) {
    this.editUserData.emit(data);
  }

  storeCommonData(data: any) {
    this.db.dispatch({type: VIEW_ITEM_MODAL, payload: data});
  }


  setOrderNotes(data: any) {
    this.db.dispatch({type: SAVE_ORDER_NOTES, payload: data});
    this.orderNotes.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('orderNotes', JSON.stringify(resp));
        }
      }
    });
  }
  storeExistingOrderNotes() {
    if (this.platformId === 'browser') {
      if (sessionStorage.getItem('orderNotes')) {
        const orderNotesStr = sessionStorage.getItem('orderNotes');
        if (!orderNotesStr) {
          return;
        }
        const data = JSON.parse(orderNotesStr);
        this.db.dispatch({type: RESTORE_ORDER_NOTES, payload: data});
      }
    }
  }

  saveCoupon(data: any) {
    this.db.dispatch({type: ADD_COUPON, payload: data});
  }
  removeCoupon() {
    this.db.dispatch({type: CLEAR_COUPON});
  }

  setParcelAdds(data: any) {
    this.db.dispatch({type: _SAVE_PARCEL_INFO, payload: data});
  }

  setDeliveryChargeInfo(data: any) {
    this.db.dispatch({type: _SAVE_DELIVERY_CHARGE, payload: data});
  }

  resetSignUpForm() {
    this.signUpForm.emit(true);
  }


  setConfirmOrder(){
    this.confirmOrderUponAccept.emit(true);
  }
  setBookingProgress(s: any) {
    this.bookingProgress.emit(s);
  }

  setOrderProgress(s: any){
    this.orderProgress.emit(s);
  }
  setErrorsData(data: any) {
    this.errors_data.emit(data);
  }

   pageRedirection(user?: any) {
    if (this.platformId === 'browser') {
      // Never allow a saved post-login redirect to bypass account verification.
      if (user && user.isVerified !== true) {
        Swal.fire({
          icon: 'warning',
          title: 'Login successful',
          text: 'Welcome back! You have signed in successfully, but your account is not verified yet. Please verify your account to continue and access all available features.',
          confirmButtonText: 'Verify My Account',
          allowOutsideClick: false
        }).then(() => {
          this.router.navigateByUrl('/my-account');
        });
        return;
      }

      this.route_page.subscribe(res => {
        if (Object.getOwnPropertyNames(res).length !== 0) {
          if (user && (user.mobile_no && user.mobile_no === '')) {
            this.router.navigateByUrl('my-setting');
          } else {
            this.router.navigateByUrl((res.page && res.page !== '') ? res.page : 'my-account').then(() => {
              if(res.page === 'reservation' && (user && user.provider)) {
                let currentUrl = this.router.url;
                this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                    this.router.navigate([currentUrl]);
                });
              }
            })
          }
        } else {
          this.router.navigateByUrl('my-account');
        }
      });
    }
  }


  addToResCart(data: any) {
    this.db.dispatch({type: RES_ADD_ITEM, payload: data});
    this.resCartData.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('resCartData', JSON.stringify(resp));
        }
      }
    });
  }

  updateToResCart(dish: any, index: any) {
    this.db.dispatch({type: RES_UPDATE_QUANTITY, payload: {dish: dish, index : index}});
    this.resCartData.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('resCartData', JSON.stringify(resp));
        }
      }
    });
  }

  removeToResCart(cartIndex: any) {
    this.db.dispatch({type: RES_DELETE_ITEM, payload: cartIndex});
    this.resCartData.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          sessionStorage.setItem('resCartData', JSON.stringify(resp));
        }
      }
    });
  }

  storeExistingResCartData() {
    if (this.platformId === 'browser') {
      if (sessionStorage.getItem('resCartData') && sessionStorage.getItem('generated_res_cart_data')) {
        const resCartDataStr = sessionStorage.getItem('resCartData');
        const generatedResCartDataStr = sessionStorage.getItem('generated_res_cart_data');
        if (!resCartDataStr || !generatedResCartDataStr) {
          return;
        }
        const data = JSON.parse(resCartDataStr);
        const generate_data = JSON.parse(generatedResCartDataStr);
        
        const md5 = new Md5();
        let checksum = md5.appendStr(JSON.stringify(data)).end();
        if(checksum === generate_data) {
          this.db.dispatch({type: RES_RESTORE_EXISTING_DATA, payload: data});
        } else {
          sessionStorage.removeItem('resCartData');
          this.db.dispatch({type: RES_CLEAR});
        }
      }
    }
  }

  clearResCart() {
    if (this.platformId === 'browser') {
      sessionStorage.removeItem('resCartData');
      this.db.dispatch({type: RES_CLEAR});
    }
  }


  saveResMenu(data: any) {
    this.db.dispatch({type: ADD_MENU, payload: data});
    this.restaurantMenu.subscribe(resp => {
      if (resp) {
        if (this.platformId === 'browser') {
          const restId = localStorage.getItem('restaurant_id');
          let _data = {
            restaurant_id: restId,
            data: resp
          }
          localStorage.setItem('res-menu', JSON.stringify(_data));
        }
      }
    });
  }
  storeExistingResMenu() {
    if (this.platformId === 'browser') {
      if (localStorage.getItem('res-menu')) {
        const resMenuStr = localStorage.getItem('res-menu');
        if (!resMenuStr) {
          return;
        }
        const data = JSON.parse(resMenuStr);
        const restId = localStorage.getItem('restaurant_id');
        if(data.restaurant_id === restId) {
          this.db.dispatch({type: ADD_MENU, payload: data.data});
        } else {
          this.removeResMenu();
        }
      }
    }
  }
  removeResMenu() {
    this.db.dispatch({type: CLEAR_MENU});
    if (this.platformId === 'browser') {
      localStorage.removeItem('res-menu');
    }
  }




}
